import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import { ConfigProvider } from "antd";
import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import { AppProvider } from "./context";
import { AppLoader } from "./components/AppLoader";
import { getAppcuesEnabled } from "./remote";

import "react-perfect-scrollbar/dist/css/styles.css";
import "./index.less";

declare global {
    interface Window {
        Affinity: {
            app?: string;
            appname?: string;
            DBWSetActiveMenuTrigger?: (eventType: string, data: any) => void;
            user?: any;
            config?: any;
            companyNumber?: string;
            employeeNumber?: string;
            hideDBWDom?: any;
            EmployeeNo?: string;
            CompanyNo?: string;
        };
        AntiForgeryToken?: string;
        myVue?: any;
        AppcuesSettings?: any;
        Appcues?: any;
    }
}

const head = document.head || document.getElementsByTagName("head")[0];
const APP_CONTAINER = document.getElementById("SS-DashboardWrapper");

if (!window.Affinity) {
    window.Affinity = { hideDBWDom: undefined };
}

window.Affinity.hideDBWDom = function () {
    document.body.classList.remove("ss-dashboard-wrapper");
    document.body.classList.add("no-ss-wrapper");
    APP_CONTAINER?.remove();
};

if (typeof URL) {
    const url = new URL(window.location.href);
    if (url.searchParams.has("InWebView")) {
        document.body.classList.remove("ss-dashboard-wrapper");
        document.body.classList.add("no-ss-wrapper");
    }
}

(function (d, w) {
    const hash =
        APP_CONTAINER?.dataset.hash ||
        APP_CONTAINER?.getAttribute("data-hash") ||
        "58cf466dd01c40a05a3b1fde97efa37462d57ba125e730d10a1346a80266e462==";
    const gFontMontserrat = d.getElementById("GFontMontserrat") || d.querySelector("link[href*=Montserrat");
    if (!gFontMontserrat) {
        const f = d.createElement("link");
        f.setAttribute("href", "https://use.typekit.net/cgw2rkw.css");
        f.setAttribute("rel", "stylesheet");
        f.setAttribute("id", "GFontMontserrat");
        f.setAttribute("nonce", hash);
        head.appendChild(f);
    }

    getAppcuesEnabled()
        .then((enabled) => {
            if (enabled) {
                const appcues = d.querySelector<HTMLScriptElement>('script[src*="206091"]');
                if (!appcues) {
                    const ac = d.createElement("script");
                    ac.src = "//fast.appcues.com/206091.js";
                    ac.nonce = hash;
                    ac.id = "dwAppcues";
                    d.body.appendChild(ac);
                    ac.onload = function () {
                        w.AppcuesSettings = { enableURLDetection: true };
                        w.Appcues.page();
                        renderApp(true);
                    };
                } else {
                    w.AppcuesSettings = { enableURLDetection: true };
                    w.Appcues.page();
                    renderApp(true);
                }
            } else renderApp();
        })
        .catch(() => renderApp());

    function renderApp(appcuesEnabled = false) {
        if (!d.body.classList.contains("no-ss-wrapper")) {
            ReactDOM.render(
                <ConfigProvider prefixCls="ss-dashboard-wrap" getPopupContainer={() => APP_CONTAINER || d.body}>
                    <React.StrictMode>
                        <AppProvider>
                            <React.Suspense fallback={<AppLoader isAppWrap={true} tip="Loading..." />}>
                                <App {...{ appcuesEnabled }} />
                            </React.Suspense>
                        </AppProvider>
                    </React.StrictMode>
                </ConfigProvider>,
                APP_CONTAINER
            );
        }
    }
})(document, window);
